import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Drawer from 'react-modern-drawer';

import { ReactComponent as CrossIcon } from '../../../assets/images/cross-secondary.svg';
import { ReactComponent as FiltersIcon } from '../../../assets/images/filters.svg';
import { useWindowSize } from '../../../hooks/useWindowResize';
import Button from '../Button/Button';

import 'react-modern-drawer/dist/index.css';
import styles from './FiltersDrawer.module.scss';

const FiltersDrawer = ({ open, handleToggleDrawer, children, handleShowResults, filtersCount, handleResetFilters }) => {
  const { t } = useTranslation('common');
  const size = useWindowSize();

  const drawerWidth = useMemo(() => {
    if (size.width > 450) return 375;
    return size.width;
  }, [size.width]);

  return (
    <Drawer
      open={open}
      onClose={handleToggleDrawer}
      direction="right"
      size={drawerWidth}
      duration={200}
      zIndex={999999}
      style={{ height: '100%' }}
    >
      <div className={styles.drawerCont}>
        <div className={styles.crossCont}>
          <CrossIcon role="presentation" onClick={handleToggleDrawer} />
        </div>
        <div className={styles.header}>
          <FiltersIcon />
          <p className={styles.heading}>{t('filters')}</p>
        </div>
        <div className={styles.divider} />
        <div className={styles.contentCont}>
          {!!filtersCount && (
            <p onClick={handleResetFilters} className={styles.clear} role="presentation">
              {t('clearAll')}
            </p>
          )}
          {children}
          <div className={styles.btnCont}>
            <Button onClick={handleShowResults}>{t('buttons.showResults')}</Button>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default FiltersDrawer;
